
































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import QuestionnaireDownloader from "@/components/QuestionnaireDownloader.vue";

axios.defaults.baseURL = process.env.BASE_URL;

@Component({
  components: { QuestionnaireDownloader }
})
export default class AdminNormatifQuestionnaireExplorer extends Vue {
  selected: any = null;
  allNormatifAnswers: any[] = [];
  searchQuery = "";
  baseurl = process.env.BASE_URL;
  getUser: any = this.$store?.getters?.getUser;
  loading = true; 

  async getAllNormatifAnswers() {
    this.loading = true; 
    try {
      const res = await axios.get("/api/normatif-answers/complete");
      this.allNormatifAnswers = (res.data || []).sort(
        (a, b) => new Date(b.creation_date).getTime() - new Date(a.creation_date).getTime()
      );
    } catch (err) {
      console.error("Erreur axios:", err);
      //this.$toast?.error("Impossible de charger les réponses.");
    } finally {
      this.loading = false; 
    }
  }

  selectQ(a: any) {
    this.selected = a;
  }

  getTestId(answer: any) {
    return answer.testId || answer.test?._id || null;
  }

  formatDate(date: string | Date) {
    if (!date) return "";
    return new Date(date).toLocaleString();
  }

  openAnswerInNewTab(answer: any) {
    const testId = this.getTestId(answer);
    const qId = answer.id;

    if (!testId || !qId) {
      this.$toast?.error("ID du test ou de la réponse manquant");
      return;
    }

    const url = `${this.baseurl}normatif-questionnaire/${testId}?qId=${qId}&viewOnly=true`;
    window.open(url, "_blank");
  }

  get filteredAnswers() {
    const filtered = this.allNormatifAnswers.filter(a => a.finished); 
    if (!this.searchQuery) return filtered;

    const q = this.searchQuery.toLowerCase();
    return filtered.filter(a =>
      (a.user?.id || "").toLowerCase().includes(q) ||
      (a.user?.company || "").toLowerCase().includes(q) ||
      (a.test?.name || "").toLowerCase().includes(q)
    );
  }

  mounted() {
    this.getAllNormatifAnswers();
  }
}
